<template>
  <QuestionnaireLayout :top="this.top">
    <v-card
      v-if="this.top"
      color="transparent"
      class="text-left mb-3"
      elevation="0"
    >
      <v-btn @click="$router.go(-1)" color="transparent" dark elevation="0">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-card>
    <v-alert
      class="text-left"
      dense
      border="left"
      type="warning"
      v-if="initialPaymentWarning"
    >
      To book an appointment or purchase a package, you need to add a payment
      method. Please click
      <v-btn x-small color="white" light depressed rounded to="/add-payment">
        here
      </v-btn>
      to add a payment method.
    </v-alert>
    <v-card :class="{ 'mb-5': $route.query.find === 'instructor' }">
      <v-card-text class="pb-0">
        <v-row>
          <v-col class="pb-0">
            <v-autocomplete
              dense
              v-model="city"
              :items="filteredCities"
              outlined
              label="Please type city name"
              :hide-selected="false"
              :search-input.sync="populateCities"
              hide-no-data
            />
          </v-col>
          <v-col cols="auto" class="pb-0">
            <v-btn
              color="primary"
              @click="search"
              :disabled="!city"
              :loading="loading"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-expansion-panels
      v-if="$route.query.find === 'instructor'"
      v-model="panel"
      multiple
      accordion
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>Choose package from the options</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-radio-group v-model="option" mandatory class="my-0 py-0">
            <v-radio
              class="mb-0"
              label="Booking individual driving lesson"
              value="booking_lesson"
            />
            <!-- <small class="ml-8 mb-2"
              >You will have to select 3 date/time options for an instructor to
              book the appointment.</small
            > -->
            <v-radio
              class="mb-0"
              label="Rent instructor's car for roadtest"
              value="roadtest_rent_car"
            />
            <!-- <small class="ml-8 mb-2"
              >You are only renting instructor car for road test.</small
            > -->
            <v-radio
              class="mb-0"
              label="Roadtest package (1hr lesson + car rental)"
              value="rentcar_n_lesson"
            />
            <!-- <small class="ml-8"
              >You are having 1 hour lesson before your road test with the
              instructor car.</small
            > -->
          </v-radio-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <template v-if="$route.query.find === 'instructor'">
      <InstructorCard
        v-for="instructor in instructors"
        :key="instructor.id"
        :instructor="instructor"
        :option="option"
        @update:option="option = $event"
        :cardAdded="paymentMethodAdded"
      />
      <no-search-results
        v-if="searchComplete && !instructors.length"
        message="Oh no! We weren’t able to match you with a nearby instructor but contact us and we will ensure we get you one as soon as we can."
      />
    </template>

    <v-alert
      class="text-left mt-5"
      dense
      border="left"
      type="warning"
      v-if="hasPackage"
    >
      You have already purchased a package from {{ this.schoolName }}
    </v-alert>
    <template v-if="$route.query.find === 'package'">
      <v-alert
        class="text-left mt-5"
        dense
        border="left"
        type="info"
        v-if="hasPackage"
      >
        10 hours course is not included in this package. Individual booking with
        instructors have to be paid separately
      </v-alert>
      <PackageCard
        v-for="pkg in packages"
        :key="pkg.id"
        :pkg="pkg"
        :hasPackage="hasPackage"
      />
      <no-search-results
        v-if="searchComplete && !packages"
        message="Oh no! We weren’t able to match you with a nearby packages but contact us and we will ensure we get you one as soon as we can"
      />
    </template>
  </QuestionnaireLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionnaireLayout from '@/components/qauestionnaire/QuestionnaireLayout'
import InstructorCard from '@/components/student/InstructorCard'
import PackageCard from '@/components/student/PackageCard'
import NoSearchResults from '@/components/student/NoSearchResults'
/** We didn't use local Cities.json here */
import rawCities from 'cities.json' // https://github.com/lutangar/cities.json

// console.log(rawCities);

const selectedCities = rawCities
  .filter(({ country }) => country === 'CA')
  .map(({ name }) => name)

console.log(selectedCities)
export default {
  data () {
    return {
      paymentMethodAdded: false,
      initialPaymentWarning: false,
      loading: false,
      searchComplete: false,
      city: '',
      filteredCityEntries: [],
      filteredAppointments: [],
      populateCities: null,
      instructors: [],
      instructorsList: [],
      packages: [],
      top: false,
      option: 'booking_lesson',
      panel: [0],
      hasPackage: false,
      schoolName: null
    }
  },
  watch: {
    populateCities (value) {
      console.log('Hre', value)
        value?.length && (this.filteredCityEntries = selectedCities)
    }
  },
  computed: {
    filteredCities () {
      console.log(this.filteredCityEntries)
      return this.filteredCityEntries
    },
    ...mapGetters([
      'instructorListProfile',
      'instructorSchoolList',
      'instructorPackage',
      'schoolListProfile',
      'user',
      'schoolPackageJoinedId'
    ])
  },
  methods: {
    ...mapActions([
      'getInstructorListProfile',
      'getSchoolListProfile',
      'getDriverxPackageByCity',
      'getInstructorsPackage',
      'getInstructorsSchool',
      'toggleDialog',
      'getSchoolPackageJoinedById'
    ]),
    async search () {
      if (!this.paymentMethodAdded) {
        this.initialPaymentWarning = true
      }
      this.loading = true
      this.top = true

      if (!this.city.length) return
      if (this.$route.query.find === 'instructor') {
        await this.getInstructorListProfile({ cityName: this.city })
        this.instructorsList = this.instructorListProfile
        if (this.instructorsList.length) {
          /** Get the school name for the instructor */
          await this.getInstructorsSchool(this.instructorsList)
          /** Get the package for instructor */
          await this.getInstructorsPackage(this.instructorSchoolList)
          /** Finally show the results */
          this.instructors = this.instructorPackage
        } else {
          /** No records found */
          this.instructors = []
          // this.toggleDialog({
          //   status: true,
          //   title: "Error",
          //   message: "No records found",
          // });
        }
      }
      if (this.$route.query.find === 'package') {
        /** See if this student already joined a school package */
        await this.getSchoolPackageJoinedById({ studentId: this.user.id })
        if (this.schoolPackageJoinedId) {
          this.hasPackage = true
          this.schoolName = this.schoolPackageJoinedId
            .get('schoolId')
            .get('name')
        }
        console.log(this.city)
        await this.getDriverxPackageByCity({
          cityName: this.city.toLowerCase()
        })
        this.packages = this.schoolListProfile
      }
      this.panel = []
      this.loading = false
      this.searchComplete = true
    },
    getColor (status) {
      switch (status) {
        case 'Declined':
          return 'red'
        case 'Pending':
          return 'grey'
        case 'Finished':
          return 'success'
        default:
          return 'primary'
      }
    },
    updateOption (val) {
      console.log({ val })
    }
  },
  components: {
    QuestionnaireLayout,
    InstructorCard,
    PackageCard,
    NoSearchResults
  },
  created () {
    /** Check if paymentMethod was added */
    if (this.user.get('stripePaymentMethodAdded')) {
      this.paymentMethodAdded = true
    }
  }
}
</script>
